// extracted by mini-css-extract-plugin
export var container = "MethodRow-module--container--3231e";
export var containerSkeleton = "MethodRow-module--containerSkeleton--f1f93";
export var disabled = "MethodRow-module--disabled--6c2de";
export var icon = "MethodRow-module--icon--92432";
export var iconSkeleton = "MethodRow-module--iconSkeleton--b1f65";
export var label = "MethodRow-module--label--e4081";
export var labelSkeleton = "MethodRow-module--labelSkeleton--7532e";
export var labels = "MethodRow-module--labels--c7c54";
export var sublabel = "MethodRow-module--sublabel--a325a";
export var trailing = "MethodRow-module--trailing--0e6ea";